// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__3KZtm","dialog":"styles_dialog__18bIJ","scrollBody":"styles_scrollBody__1GtET"};